import { useQueryCache } from "@pinia/colada";

export function useAddGiftCardForm() {
  const queryCache = useQueryCache();
  return useFormHandler<{ message: string; cart: Cart }>({
    schema: addGiftCardSchema,
    action: "add_gift_card",
    onSuccess: ({ cart }) => queryCache.setQueryData(["cart"], cart),
  });
}
